export const TRANSLATIONS_TH = {
  leftNavigation: {
    dashboard: "แผงควบคุม",
    sessions: "เซสชั่น",
    teams: "ทีม",
    profile: "ข้อมูลส่วนตัว",
    logs: "บันทึก",
    warningLetters: "จดหมายเตือน",
    settings: "การตั้งค่า",
    userManagement: "การจัดการผู้ใช้",
    subjectManagement: "การจัดการหัวข้อ",
    changePassword: "เปลี่ยนรหัสผ่าน",
    helpAndSupport: "ช่วยเหลือและสนับสนุน",
    scoresheet: "Scoresheet",
  },
  header: {
    logout: "ออกจากระบบ",
    notifications: "การแจ้งเตือน",
    loadingNotifications: "Loading การแจ้งเตือน....",
    stepper: {
      plan: "ขั้นตอนการวางแผน",
      do: "ขั้นตอนการปฏิบัติ",
      check: "ขั้นตอนการตรวจสอบ",
      act: "ขั้นตอนการดำเนินงานให้เหมาะสม",
    },
  },
  tabs: {
    ceo: "CEO",
    executive: "Executive",
    coe: "COE",
    campaign: "แคมเปญ",
    team: "ทีม",
    personal: "Personal",
  },
  notification: {
    session: "You have a coaching session with ",
    on: "on ",
    checkpointUpdated: "has updated the checkpoint date",
    complete: "Please complete the GROW Model by",
    growmodel: "has completed the GROW Model and accepted your invitation",
    progression: "has updated Your progression ",
    compliment: "gave you a compliment!'",
    rating: "Please rate your coaching session with",
    review: "has changed your final review date to",
    archivedSession: "has rated and archived the coaching session!",
    checkpoint: "Checkpoint",
    updateFor: "update for",
    isAvailable: "is available",
    at: "at",
    today: "today",
    youHaveYetToSetCheckPoint: "You have yet to set checkpoint for",
    by: "by",
    youHaveAReviewSessionWith: "คุณมีเซสชั่นรีวิวกับ",
    youHaveUpcomingSession: "You have an upcoming session with",
    youHaveCompleted: "You have completed",
    sessionCompletedLastMonth: "session(s) in the last month",
  },
  dashboard: {
    title: "แผงควบคุม",
    noDataYet: "ยังไม่มีข้อมูล",
    tabs: {
      ceo: "CEO",
      executive: "Executive",
      coe: "COE",
      campaign: "แคมเปญ",
      team: "ทีม",
      personal: "Personal",
    },
    coachingSessionWith: "Coaching Session With",
    checkpointSetupFor: "Checkpoint setup for",
    checkpointUpdateFor: "Checkpoint update for",
    reviewSessionWith: "Review session with",
    average: "เฉลี่ย",
    longest: "ยาวที่สุด",
    shortest: "สั้นที่สุด",
    executive: {
      sessionClosed: "Session closed",
      overall: "Overall",
      totalInprogress: "Total in progress",
      avgUsageRate: "Avg usage rate",
      usageRate: "Usage rate",
      totalSessionClosed: "Total sessions closed",
      totalCoachees: "Total coachees",
      avgSessionClosed: "ค่าเฉลี่ยเซสชั่นที่เรียบร้อยแล้ว",
      coachingHours: "ชั่วโมงการโค้ช",
      totalCoachingHours: "ชั่วโมงการโค้ชทั้งหมด",
      avgCoachingHours: "ค่าเฉลี่ยชั่วโมงการโค้ช",
      totalPlanDuration: "ระยะเวลาทั้งหมดของขั้นตอนการวางแผน",
      totalDoDuration: "ระยะเวลาทั้งหมดขั้นตอนการปฏิบัติ",
      totalCheckDuration: "ระยะเวลาทั้งหมดขั้นตอนการตรวจสอบ",
      totalActDuration: "ระยะเวลาทั้งหมดขั้นตอนการดำเนินงานให้เหมาะสม",
      coachingSubjects: "หัวข้อการโค้ช",
    },
    coach: {
      dashboard: "แผงควบคุม",
      report: "รายงาน",
      upcomingTask: "งานที่กำลังจะเกิดขึ้น",
      overdueTask: "งานที่เลยกำหนด",
      recentTask: "กิจกรรมล่าสุด",
      top3coaches: "3 ลำดับการโค้ช",
      campaignSession: "เซสชั่นของโปรเจค",
      totalCoach: "จำนวนผู้ถูกโค้ชทั้งหมด",
      coached2OrMoreSession: "โค้ช 2 ครั้งขึ้นไป",
      coached1Session: "โค้ช 1 ครั้ง",
      notCoachedYet: "ยังไม่มีการโค้ช",
      showResultFor: "แสดงผลของ",
      happiness: "ความสุข",
      complimentLikes: "ถูกใจคำชมเชย",
      success: "ความสำเร็จ",
      ratedSession: "ให้คะแนนเซสชั่น",
      totalSession: "เซสชันทั้งหมด",
      likes: "ถูกใจ",
      totalComplements: "คำชมเชยทั้งหมด",
      passRate: "อัตราการผ่าน",
      totalSubjects: "หัวข้อทั้งหมด",
      comparedTo: "เปรียบเทียบกับ",
      mostCoachedSubjects: "หัวข้อที่ได้รับการโค้ชมากที่สุด",
      average: "ค่าเฉลี่ย",
      mostFailedSubjects: "หัวข้อที่ตกมากที่สุด",
      topSkillsToImprove: "หัวข้อทักษะที่ต้องปรับปรุงมากที่สุด",
      teamAverage: "ค่าเฉลี่ยทีม",
      coach: "โค้ช",
      typeOfSession: "ประเภทของเซสชั่น",
      subjects: "หัวข้อ",
      session: "เซสชั่น",
      sessionDuration: "ระยะเวลาเซสชัน",
      length: "ความยาว",
      minutes: "นาที",
      longest: "ยาวที่สุด",
      shortest: "สั้นที่สุด",
      plan: "ขั้นตอนการวางแผน",
      do: "ขั้นตอนการปฏิบัติ",
      check: "ขั้นตอนการตรวจสอบ",
      act: "ขั้นตอนการดำเนินงานให้เหมาะสม",
      total: "ยอดรวม",
      individual: "รายบุคคล",
      metricsHead: "สมาชิกในทีมได้รับการโค้ช",
      complianceRate: "อัตราการปฏิบัติตาม",
      incompleteRate: "อัตราที่ไม่สมบูรณ์",
      conditionalPassRate: "อัตราการผ่านแบบมีเงื่อนไข",
      campaign: "แคมเปญ",
      sessions: "เซสชั่น",
      manual: "คู่มือ",
      expired: "หมดอายุ",
      team: "ทีม",
      campaignAverage: "ค่าเฉลี่ยของแคมเปญ",
      topCountries: "ประเทศอันดับต้นๆ",
    },
    personal: {
      dashboard: "แผงควบคุม",
      showResultFor: "แสดงผลของ",
      happiness: "ความสุข",
      complimentLikes: "ถูกใจคำชมเชย",
      success: "ความสำเร็จ",
      ratedSession: "ให้คะแนนเซสชั่น",
      totalSession: "เซสชันทั้งหมด",
      likes: "ถูกใจ",
      totalComplements: "คำชมเชยทั้งหมด",
      passRate: "อัตราการผ่าน",
      totalSubjects: "หัวข้อทั้งหมด",
      latestCompliments: "คำชมเชยล่าสุด",
      comparedToTeamAvg: "เปรียบเทียบกับค่าเฉลี่ยของทีม",
      mostCoachedSubjects: "หัวข้อที่ได้รับการโค้ชทั้งหมด",
      mostFailedSubjects: "หัวข้อที่ตกมาที่สุด",
      topSkillsToImprove: "หัวข้อทักษะที่ต้องปรับปรุงมากที่สุด",
      individual: "รายบุคคล",
      teamAverage: "ค่าเฉลี่ยของทีม",
      subjects: "หัวข้อ",
      session: "เซสชั่น",
    },
    selectReport: "Select Report",
    overallCoachingSessionsReport: "Overall Coaching Sessions Report",
    sessionDiscussionReport: "Session Discussion Report",
    monthly: "Monthly",
    custom: "Custom",
    cancel: "Cancel",
    download: "Download",
  },
  sessionList: {
    title: "เซสชั่น",
    totalSessionPending: "เซสชันทั้งหมดที่รอดำเนินการ",
    allCoaches: "โค้ชทั้งหมด",
    allStatus: "สถานะทั้งหมด",
    upcomingSession: "เซสชั่นที่จะเกิดขึ้น",
    sessionDateTime: "Session Date",
    time: "เวลา",
    type: "ประเภท",
    subjects: "หัวข้อ",
    coach: "โค้ช",
    coachee: "ผู้ถูกโค้ช",
    status: "สถานะ",
    createSession: "สร้างเซสชั่น",
    allCountries: "ประเทศทั้งหมด",
    allCampaign: "แคมเปญทั้งหมด",
    sessionSuccess: "เซสชันที่เสร็จเรียบร้อยแล้ว",
    name: "ชื่อ",
  },
  createSession: {
    backToSession: "กลับไปที่เซสชั่น",
    createNewSession: "สร้างเซสชั่นใหม่",
    campaign: "แคมเปญ",
    coachee: "Coachee",
    coach: "Coach",
    assignToOtherCoach: "มอบหมายให้โค้ชท่านอื่น",
    assignTo: "มอบหมายให้",
    selectTeamMember: "เลือกสมาชิกในทีม",
    viewCoacheesStates: "ดูประวัติบันทึกการโค้ช",
    coachingDate: "วันที่โค้ช",
    method: "วิธีการโค้ช",
    framework: "โครงสร้าง",
    reviewDate: "วันรีวิว",
    typeOfSession: "ประเภทของเซสชั่น",
    addSubjects: "เพิ่มหัวข้อ",
    sessionNotes: "บันทึกเซสชัน",
    keyPoint: "จุดสำคัญ",
    addNewNote: "เพิ่มบันทึกใหม่",
    compliment: "ชมเชย",
    casualNote: "บันทึกย่อ",
    createSendInvitation: "สร้างและส่งคำเชิญ",
    assignFieldMandatory: "ส่วนนี้ต้องระบุ",
    coacheeFieldMandatory: "ส่วนนี้ต้องระบุ",
    logs: "บันทึก",
    complettionDate: "วันที่เสร็จสมบูรณ์",
    duration: "ระยะเวลา",
    type: "ประเภท",
    subjects: "หัวข้อ",
    name: "ชื่อ",
    status: "สถานะ",
    noTeamLogsFound: "ไม่พบบันทึกของทีม",
    close: "ปิด",
    methodIsMandatory: "ส่วนนี้ต้องระบุ",
    frameworkIsMandatory: "ส่วนนี้ต้องระบุ",
    sessionTypeIsMandatory: "ส่วนนี้ต้องระบุ",
    pleaseAddAtLeastOneSubject: "โปรดระบุอย่างน้อย 1 หัวข้อ",
    selectAcoach: "เลือกโค้ช",
    ErrorNetworkError: "ข้อผิดพลาด: ข้อผิดพลาดของเครือข่าย",
    notes: "บันทึก",
  },
  sessionDetails: {
    backtosession: "กลับไปที่เซสชั่น",
    sessionDetails: "รายละเอียดเซสชั่น",
    coach: "โค้ช",
    coachee: "ผู้ถูกโค้ช",
    caochingDate: "วันที่โค้ช",
    reviewDate: "วันรีวิว",
    typeofSession: "ประเภทของเซสชั่น",
    subjects: "หัวข้อ",
    gentleReminderTitle: "การแจ้งเตือน",
    gentleReminder:
      "การแจ้งเตือน: อ่านประเด็นสำคัญบนแผงด้านขวาก่อนเริ่มการเตรียมเซสชั่นของคุณ",
    startPreparation: "เริ่มการเตรียมการ",
  },
  growForm: {
    planSessionBasedonGrowModel: "วางแผนเซสชันตาม GROW Model",
    yourReviewSessionIsOn: "เซสชั่นการตรวจสอบของคุณเป็นวันที่",
    goals: "เป้าหมาย",
    comment: "ความคิดเห็น",
    knowingYourCoachingSubjectsAndCreate:
      "ดูหัวข้อการโค้ชของคุณและสร้างแผนเพื่อให้บรรลุเป้าหมายภายในกำหนดวันรีวิวโดยใช้เป้าหมายแบบสมาร์ท (SMART)",
    SMARTGolasIsAnEstablished:
      "SMART Goals เป็นวิธีที่กำหนดขึ้นในการวางแผนและบรรลุเป้าหมาย\n การสร้างเป้าหมาย SMART ช่วยสร้างการตระหนักรู้ในสิ่งที่คุณต้องการทำให้สำเร็จ วิธีการบรรลุเป้าหมายของคุณ เป้าหมายของคุณสามารถทำได้ไหมและมีความเกี่ยวข้องกับเนื้องานหรือไม่ และเมื่อใดที่คุณต้องทำให้บรรลุเป้าหมาย",
    reality: "สถานะปัจจุบัน",
    current: "ปัจจุบัน",
    target: "เป้าหมาย",
    enterMetrics: "ใส่เมตริก",
    knowingYourCurrentPerformance:
      "รู้ผลการปฏิบัติงานในปัจจุบันของคุณที่เกี่ยวข้องกับหัวข้อการโค้ช",
    options: "ทางเลือก",
    brainstormForMultipleOptionsToImprove:
      "ระดมความคิดเพื่อหาทางเลือกที่หลากหลายเพื่อปรับปรุงหัวข้อการโค้ช เพื่อให้บรรลุเป้าหมาย แจกแจงเทคนิคที่เป็นไปได้ที่สามารถช่วยแก้ปัญหาต่างๆ ขั้นตอนนี้ส่งเสริมความคิดสร้างสรรค์ในการค้นหาแนวทางแก้ไขที่เป็นไปได้",
    wayForward: "สิ่งที่จะเกิดขึ้น",
    selectTheMostFeasibleOptions:
      "เลือกตัวเลือกที่เป็นไปได้มากที่สุดที่สามารถบรรลุเป้าหมายของคุณได้สำเร็จ",
    saveAndConfirmSession: "บันทึกและยืนยันเซสชัน",
    startCoachingSession: "เริ่มเซสชันการโค้ช",
    edit: "แก้ไข",
    startCoaching: "เริ่มการโค้ช",
    proceedToSummary: "ดำเนินการสรุป",
    skillToImprove: "ทักษะที่ต้องปรับปรุง",
    selectSkill: "เลือกทักษะ",
    pleaseSelectSkillsToImprove: "โปรดเลือกทักษะที่จะปรับปรุง",
    enterProjectKpi: "Enter Project Target KPI",
    projectTargetKpi: "Project Target KPI",
  },
  coachingSummary: {
    coachingSummary: "โค้ช",
    coach: "ผู้โค้ช",
    coachee: "วันที่โค้ช",
    coachingDate: "วิธีการโค้ช",
    method: "ประเภทของเซสชั่น",
    typeOfSession: "เป้าหมาย",
    goals: "สถานะปัจจุบัน",
    reality: "ปัจจุบัน",
    current: "เป้าหมาย",
    target: "ทักษะที่ต้องปรับปรุง",
    skillToImprove: "ทางเลือก",
    options: "สิ่งที่จะเกิดขึ้น",
    wayForward: "เซสชั่นการตรวจสอบของคุณเป็นวันที่",
    yourReviewSessionWillBe:
      "จุดตรวจความคืบหน้าจะถูกตั้งค่าและอัปเดตโดยโค้ชของคุณก่อนวันรีวิว",
    progressionCheckpoints: "การรับทราบ",
    acknowledgement: "ใส่รหัสผ่าน",
    enterPassword: "กรุณาใส่รหัสผ่าน",
    pleaseEnterPassword: "จบการโค้ช",
    byAcknowledgingthisGrow:
      "การยอมรับแบบฟอร์ม GROW นี้แสดงว่าคุณตกลงที่จะดำเนินการในแผนปฏิบัติการที่ระบุไว้\n การยอมรับแบบฟอร์ม GROW นี้แสดงว่าคุณตกลงที่จะทำงานในแผนปฏิบัติการที่ระบุไว้",
    endCoaching: "ยกเลิก",
    cancel: "ยอมรับ",
    agree: "Agree",
  },
  setCheckpoint: {
    backToSession: "กลับไปที่เซสชั่น",
    setCheckpoint: "ตั้งจุดตรวจ",
    viewSessionSummary: "ดูสรุปเซสชั่น",
    rateCoacheesBehaviour: "ประเมินพฤติกรรมของโค้ช",
    checkpoint: "จุดตรวจที่",
    addCheckpoint: "เพิ่มจุดตรวจ",
    reviewDate: "วันรีวิว",
    gentleReminder:
      "คำเตือน: คุณจะไม่สามารถเปลี่ยนการให้คะแนนพฤติกรรมของผู้ถูกโค้ชได้หลังจากที่คุณได้ยืนยันการให้คะแนนและจุดตรวจสอบแล้ว",
    pleaseRateTheCoachees: "กรุณาให้คะแนนพฤติกรรมของผู้ถูกโค้ช",
    confirmRatingAndCheckpoints: "ยืนยันการให้คะแนนและจุดตรวจ",
  },
  sessionSummary: {
    viewSessionSummary: "ดูสรุปเซสชั่น",
    coach: "โค้ช",
    coachee: "ผู้ถูกโค้ช",
    coachingDate: "วันที่โค้ช",
    method: "วิธีการ",
    typeOfSession: "ประเภทของเซสชั่น",
    goals: "เป้าหมาย",
    reality: "สถานะปัจจุบัน",
    current: "ปัจจุบัน",
    target: "เป้าหมาย",
    skillsToImprove: "ทักษะที่ต้องปรับปรุง",
    options: "ทางเลือก",
    wayForward: "สิ่งที่จะเกิดขึ้น",
  },
  updateCheckpoint: {
    updateCheckpoint: "อัพเดทคะแนนที่จุดตรวจ",
    edit: "แก้ไข",
    viewSessionSummary: "ดูสรุปเซสชั่น",
    reviewDate: "วันรีวิว",
    checkpoint: "จุดตรวจที่",
    final: "จุดตรวจสุดท้าย",
    previous: "ก่อนหน้านี้",
    checkpointProgressScore: "บันทึกคะแนนความคืบที่จุดตรวจเรียบร้อยแล้ว",
    saveProgress: "บันทึกคะแนนความคืบหน้า",
    startReviewSession: "เริ่มเซสชันรีวิว",
    postPoneReviewSession: "เลื่อนเซสชั่นรีวิว",
    postPoneReviewSessionTo: "เลื่อนเซสชั่นรีวิวไปเป็นวันที่",
    pleaseStateReason: "กรุณาระบุเหตุผล",
    cancel: "ยกเลิก",
    schedule: "กำหนดการ",
  },
  reviewSession: {
    reviewSession: "เซสชั่นรีวิว",
    finalReview: "รีวิวครั้งสุดท้าย",
    final: "จุดตรวจสุดท้าย",
    summary: "สรุป",
    proceedToSummary: "ดำเนินการสรุป",
    summaryFieldIsRequired: "ส่วนนี้ต้องระบุ",
    sessionReviewSummarySavedSuccessfully:
      "บันทึกสรุปการรีวิวเซสชันเรียบร้อยแล้ว!",
    endReviewSession: "จบการรีวิวเซสชั่น",
    done: "เสร็จเรียบร้อย",
  },
  archiveSession: {
    backtoSession: "กลับไปที่เซสชั่น",
    backToLog: "Back to Logs",
    archiveSession: "บันทึกเซสชั่น",
    areYouSatisfied: "คุณพอใจกับเซสชั่นนี้หรือไม่?",
    pleaseReadTHeSessionSummary:
      'โปรดอ่านสรุปเซสชั่นและหมายเหตุอย่างละเอียด\n คุณไม่สามารถกด "ถูกใจ" คำชมได้อีกต่อไปกดบันทึกเก็บเซสชันนี้แล้ว',
    totalDuration: "ระยะเวลาทั้งหมด",
    durationBreakdown: "รายละเอียดระยะเวลา",
    viewReviewSessionSummary: "ดูสรุปเซสชั่น",
    coacheesBehaviour: "พฤติกรรมของผู้ถูกโค้ช",
    reviewDate: "วันที่ตรวจสอบ",
    finalReview: "ทบทวนขั้นสุดท้าย",
    summary: "สรุป",
    notes: "หมายเหตุ",
    selectYourFeedback: "เลือกคำติชมของคุณ",
  },
  personalProfile: {
    fullName: "ชื่อเต็ม",
    employeeID: "รหัสพนักงาน",
    campaign: "แคมเปญ",
    market: "ทีม",
    designation: "ตำแหน่ง",
    coach: "โค้ช",
    viewSession: "ดูเซสชั่น",
    viewLogs: "ดูบันทึก",
    personalProfile: "รายละเอียดส่วนบุคคล",
  },
  teams: {
    coach: "โค้ช",
    taggedCoaches: "ติดแท็กโค้ช",
    untaggedCoachees: "ยกเลิกการแท็กโค้ช",
    searchFilter: "ตัวกรองการค้นหา",
    employeeId: "รหัสพนักงาน",
    Campaign: "แคมเปญ",
    department: "แผนก",
    subunit: "หน่วยย่อย",
    lastSession: "เซสชั่นล่าสุด",
    upcommingSession: "เซสชั่นที่จะเกิดขึ้น",
    totalCoachees: "รวมโค้ชทั้งหมด",
    members: "สมาชิก",
    coaches: "โค้ช",
    allCountries: "ทุกประเทศ",
    allCampign: "แคมเปญทั้งหมด",
    teams: "ทีม",
    name: "ชื่อ",
  },
  logs: {
    allCoaches: "โค้ชทั้งหมด",
    searchFilter: "ตัวกรองการค้นหา",
    completionDate: "วันที่เสร็จสมบูรณ์",
    duration: "ระยะเวลา",
    subjects: "หัวข้อ",
    coach: "โค้ช",
    coachee: "ผู้ถูกโค้ช",
    status: "สถานะ",
    totalLogs: "บันทึกทั้งหมด",
    type: "Type",
    averageDuration: "ระยะเวลาเฉลี่ย (นาที)",
    longestDuration: "ระยะเวลานานที่สุด (นาที)",
    shortestDuration: "ระยะเวลาที่สั้นที่สุด (นาที)",
    filter: "ตัวกรอง",
    names: "ชื่อ",
    name: "ชื่อ",
    clearAll: "ลบทั้งหมด",
    allCountries: "ทุกประเทศ",
    AllCampaign: "แคมเปญทั้งหมด",
  },
  userManagement: {
    searchFilter: "ตัวกรองการค้นหา",
    name: "ชื่อ",
    id: "Id",
    campaign: "แคมเปญ",
    department: "แผนก",
    country: "ประเทศ",
    designation: "ตำแหน่ง",
    role: "บทบาท",
    status: "สถานะ",
    editUser: "แก้ไขผู้ใช้",
    fullName: "ชื่อเต็ม",
    employeeID: "หมายเลขพนักงาน",
    adminRole: "ผู้ดูแลระบบ",
    managerCoache: "การจัดการผู้ถูกโค้ช",
    AddCoach: "เพิ่มโค้ช",
    userStatus: "สถานะผู้ใช้",
    resetPassword: "รีเซ็ตรหัสผ่าน",
    saveChanges: "บันทึกการเปลี่ยนแปลง",
    cancel: "ยกเลิก",
    add: "เพิ่ม",
    userDetailsUp: "อัปเดตรายละเอียดผู้ใช้เรียบร้อยแล้ว",
    pleaseSaveToResetThe: "โปรดบันทึกเพื่อรีเซ็ตรหัสผ่าน",
  },
  subjectManagement: {
    searchFilter: "ตัวกรองการค้นหา",
    campaign: "แคมเปญ",
    department: "แผนก",
    lastEdited: "แก้ไขล่าสุด",
    date: "วันที่",
    subjectFor: "หัวข้อสำหรับ",
    status: "สถานะ",
    country: "ประเทศ",
    coachingCategory: "หมวดหมู่การโค้ช",
    subCategory: "หมวดหมู่ย่อย",
    dataType: "ประเภทข้อมูล",
    conditionToPass: "เงื่อนไขการให้ผ่าน",
    framework: "โครงสร้าง",
    enterSubCategory: "ใส่หมวดหมู่ย่อย",
    selectType: "เลือกประเภท",
    selectCondition: "เลือกเงื่อนไขการให้ผ่าน",
    selectFramework: "เลือกโครงสร้าง",
    addSubCategory: "เพิ่มหมวดหมู่ย่อย",
    skillToImprove: "ทักษะที่ต้องปรับปรุง",
    enterSkillToImprove: "ใส่ทักษะที่ต้องปรับปรุง",
    addLevel: "เพิ่มระดับ",
    addSkillToImprove: "เพิ่มทักษะที่ต้องปรับปรุง",
    actionAtCheckpoint: "การดำเนินการที่จุดตรวจ",
    enterAction: "ใส่การดำเนินการ",
    addAction: "เพิ่มการดำเนินการ",
    saveChanges: "บันทึกการเปลี่ยนแปลง",
    cancel: "ยกเลิก",
    editSubject: "แก้ไขหัวเรื่อง",
    subjectDetails: "อัพเดทรายละเอียดหัวเรื่องอัพเดท",
    noRecordFound: "ไม่พบบันทึก",
    somethingWentWrong: "เกิดข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง",
    functionalUnit: "Sub Functional Unit",
  },
  changePassword: {
    enterYourCurrentPassowrd: "ใส่รหัสผ่านปัจจุบันของคุณ",
    chooseAStrongPassword: "เลือกรหัสผ่านที่รัดกุมและอย่าใช้ซ้ำกับบัญชีอื่น",
    newPassword: "รหัสผ่านใหม่",
    passwordStrength: "ความปลอดภัยของรหัสผ่าน",
    useAtLeast12Charecters:
      "ใช้อักขระอย่างน้อย 12 ตัว อย่าใช้รหัสผ่านจากเว็บไซต์อื่นหรือรหัสที่ชัดเจนเกินไป",
    confirmNewPassword: "ยืนยันรหัสผ่านใหม่",
    changePassword: "เปลี่ยนรหัสผ่าน",
    thePasswordDoNotMatch: "รหัสผ่านไม่ตรงกัน",
    passwordMustBeAtLeast12:
      "รหัสผ่านต้องมีความยาวอย่างน้อย 12 อักขระ ตัวเลข 1 ตัว อักขระพิเศษ 1 ตัว และตัวพิมพ์ใหญ่ 1 ตัว",
    passwordCannotBeSameAsOldPassword: "New password cannot be same as old password",
  },
  error: {
    loginerror: "Uh-oh, either your details are incorrect, or your account’s inactive",
    usererror: "user is not active",
    internalServerError: "something went wrong, please try again",
    networkerror: {
      500: "Something went wrong",
    },
    paramerror: "'Value of ' + property + ' can not be null.",
    passwordvalidationerror:
      "Password must be at least 10 characters long, one number, one special character and one upper case letter",
    newpasswordvalidationerror: "new password and confirm doesn't match",
    oldpasswordvalidationerror: "old password doesn't match",
    successpasswordvalidationerror: "password successfully changed",
    noSessionDetailsFound: "No session details found",
    verbalWarningIssued: "Verbal warning issued",
    verbalWarningIssueFailed: "Failed to issue verbal warning, try again",
    alreadyTwoVerbalWarningIssued:
      "Already 2 verbal warning issued, try for other",
    checkpointProgressScoreHasBeenSavedSuccessfully:
      "Checkpoint Progress Score has been saved successfully",
    updatedCheckpointsSuccessfully: "Updated Checkpoints successfully",
    sessionReviewSummaryHasBeenSavedSuccessfully:
      "Session Review Summary has been saved successfully",
    selectedCoachIsAlreadyInTheList: "Selected Coach is already in the list",
    somethingWentWrongPleaseTryAgain: "something went wrong, please try again",
    couldNotGetSession: "Could not get session.",
    selectedCoacheeIsAlreadyBeenAdded: "Selected coachee is already been added",
    selectedCountryIsAlreadyInTheList:
      "Selected Country is already in the list",
    canNotUpdateActionAtCheckPoint: "can't update action_at_checkpoint!",
    couldNotGetCountryList: "Could not get Country List",
    couldNotGetNotification: "Could not get notification",
    errorGettingReviewDateSummary: "Error getting Review Date Summary",
    pleaseSelectCoachee: "Please select Coachee",
    couldNotGetGrowFormDetailsFromSessionId:
      "Could not get grow form details from session id",
    pleaseSelectSubjectAndAddMetrics: "Please select subject and add metrics",
    couldNotGetSkillsListBasedOnSubjectId:
      "Could not get Skills list based on subject id",
  },
  editSessionCoachingDates: {
    title: "Postpone Session Dates",
    update: "Update",
  },
  common: {
    noRecordFound: "No record found",
    backToSession: "กลับไปที่เซสชั่น",
  },
};
